export default __webpack_public_path__ + "static/media/ngrx.b49f3c62.png";